import { Button, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import type { MetricExtensionRow } from "./metricExtensionsManagementState";

interface Props {
  onClose: () => void;
  extensionRow: MetricExtensionRow;
  onRename: (rowId: string, newExtensionValue: string) => void;
}

const RenameMetricExtensionDialog = ({ onClose, extensionRow, onRename }: Props) => {
  const [newValue, setNewValue] = useState(extensionRow.extensionValue);

  const handleApply = () => {
    onRename(extensionRow.id, newValue);
    onClose();
  };

  return (
    <SmallDialog open>
      <DialogTitle>Rename Metric Extension</DialogTitle>
      <DialogCloseButton onClick={onClose} />

      <DialogContent>
        <TextField fullWidth value={newValue} onChange={(e) => setNewValue(e.target.value)} error={!newValue} />
      </DialogContent>

      <DialogButtons onCancel={onClose}>
        <Button
          color="primary"
          variant="contained"
          onClick={handleApply}
          disabled={!newValue || newValue.trim() === extensionRow.extensionValue}
        >
          Apply
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default RenameMetricExtensionDialog;
